import React from 'react';

const TextSizeIcon = ({ size }) => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    aria-hidden="true"
  >
    <text 
      x="12" 
      y="16" 
      textAnchor="middle" 
      fontSize={size} 
      fontFamily="Arial, sans-serif"
      fontWeight="bold"
    >
      A
    </text>
  </svg>
);

function TextSizeControl({ textSize, onTextSizeChange }) {
  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();
        onTextSizeChange('increase');
        break;
      case 'ArrowDown':
        event.preventDefault();
        onTextSizeChange('decrease');
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        onTextSizeChange('reset');
        break;
      default:
        break;
    }
  };

  const getSizeLabel = () => {
    switch (textSize) {
      case 'extra-small': return 'Extra small text';
      case 'small': return 'Small text';
      case 'large': return 'Large text';
      case 'extra-large': return 'Extra large text';
      default: return 'Default text size';
    }
  };

  return (
    <div className="text-size-control" role="group" aria-label="Text size controls">
      <button
        className="text-size-btn decrease"
        onClick={() => onTextSizeChange('decrease')}
        onKeyDown={handleKeyDown}
        aria-label="Decrease text size (Arrow Down)"
        title="Decrease text size"
        disabled={textSize === 'extra-small'}
      >
        <TextSizeIcon size="8" />
      </button>
      
      <button
        className="text-size-btn reset"
        onClick={() => onTextSizeChange('reset')}
        onKeyDown={handleKeyDown}
        aria-label={`Reset to default text size (Enter or Space). Current: ${getSizeLabel()}`}
        title="Reset to default size"
      >
        <TextSizeIcon size="10" />
      </button>
      
      <button
        className="text-size-btn increase"
        onClick={() => onTextSizeChange('increase')}
        onKeyDown={handleKeyDown}
        aria-label="Increase text size (Arrow Up)"
        title="Increase text size"
        disabled={textSize === 'extra-large'}
      >
        <TextSizeIcon size="12" />
      </button>
    </div>
  );
}

export default TextSizeControl;
